<template>
  <v-row>
    <v-col>
      <template v-if="img">
        <v-img :id="id" :src="img" :aspect-ratio="$vuetify.breakpoint.xs ? 1:2.5"></v-img>
      </template>
      <template v-else>
        <v-img src="@/assets/uploadImage.jpg" :aspect-ratio="$vuetify.breakpoint.xs ? 1:2.5"></v-img>
      </template>
      <v-row>
        <v-col>
          <span class="text-uppercase text-tcdc-green sub-header1 bold">
            {{name}}
          </span>
        </v-col>
      </v-row>
      <Divider />
      <v-row>
        <v-col class="text-left text-tcdc-green">
          <div class="d-flex flex-1 align-center">
            <img src="../../assets/icons/sorts/calendar.png" class="eventcard-logo pr-4" />
            <span class="bold">{{ time_start }} - {{ time_end }}</span>
          </div>
        </v-col>
        <v-col class="text-right">
          <div class="d-flex flex-1 align-center justify-end">
            <img src="../../assets/icons/marker.png" class="eventcard-logo pr-4" />
            <span class="text-tcdc-green bold">{{ place }}</span>
          </div>
        </v-col>
      </v-row>
      <Divider />
    </v-col>
  </v-row>
</template>

<script>
import Divider from "../../components/dividers/Divider";
export default {
  props: {
    name: {
      type: String,
      default: ""
    },
    time_start: {
      type: String,
      default: ""
    },
    time_end: {
      type: String,
      default: ""
    },
    place: {
      type: String,
      default: ""
    },
    id : {
      type: Number,
      default: 1
    },
    img : {
      type: String,
      default: ''
    },
  },
  components: {
    Divider
  }
};
</script>

<style scoped>
.eventcard-logo {
  height: 25px;
  object-fit: contain;
}
</style>
